export default defineNuxtPlugin((nuxtApp) => {
    nuxtApp.hook('page:transition:finish', () => {
        const { lenis } = getLenis('global');
        lenis.scrollTo(0, {
            immediate: true,
        });
    });
});
